import styled from "styled-components";

export const DatePickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;

  label {
    margin: 0;
    color: #6d6d6d;
    font-size: 14px;
    font-weight: 600;
  }

  .date-range-input {
    width: 100%;
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    padding: 0 0.75rem;
    height: 40px;
    font-size: 14px;
    color: #333;
  }

  .date-range-input:focus {
    border-color: #1976d2;
    outline: none;
    box-shadow: 0 0 0 1px #1976d2;
  }

  .react-datepicker-popper {
    z-index: 20;
  }
`;
